import ApiService from "./api.service";

// Backend JSON'ni PascalCase ("Subject", "TypeName") qaytaradi, loyihadagi
// qolgan servislar esa camelCase bilan ishlaydi. Kalitlarni bir marta shu yerda
// camelCase'ga o'tkazamiz — komponentlar hamma joyda bir xil yozuvda yozadi.
function toCamel(value) {
  if (Array.isArray(value)) return value.map(toCamel);
  if (value === null || typeof value !== "object") return value;
  if (value instanceof Blob || value instanceof FormData) return value;

  const result = {};
  Object.keys(value).forEach((key) => {
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
    result[camelKey] = toCamel(value[key]);
  });
  return result;
}

function camelize(response) {
  response.data = toCamel(response.data);
  return response;
}

const XabarnomaService = {
  GetTypes() {
    return ApiService.get(`/Xabarnoma/GetTypes`).then(camelize);
  },
  GetList(data) {
    return ApiService.post(`/Xabarnoma/GetList`, {
      Search: data.search || null,
      Direction: data.direction || null,
      TypeId: data.typeId || null,
      Page: data.page,
      PageSize: data.pageSize,
    }).then(camelize);
  },
  GetDetail(recipientId) {
    return ApiService.get(`/Xabarnoma/GetDetail/${recipientId}`).then(camelize);
  },
  AddRecipientComment(recipientId, comment) {
    return ApiService.post(`/Xabarnoma/AddRecipientComment`, {
      RecipientId: recipientId,
      Comment: comment,
    });
  },
  SubmitReply(recipientId, replyText, fileIds) {
    return ApiService.post(`/Xabarnoma/SubmitReply`, {
      RecipientId: recipientId,
      ReplyText: replyText,
      FileIds: fileIds || [],
    }).then(camelize);
  },
  UploadReplyFile(file) {
    const fd = new FormData();
    fd.append("files", file);
    return ApiService.formData(`/Xabarnoma/UploadReplyFile`, fd).then(camelize);
  },
  DeleteReplyFile(fileId) {
    return ApiService.post(`/Xabarnoma/DeleteReplyFile/${fileId}`);
  },
  DownloadFile(fileId) {
    return ApiService.print(`/Xabarnoma/DownloadFile/${fileId}`);
  },
  DownloadReplyFile(fileId) {
    return ApiService.print(`/Xabarnoma/DownloadReplyFile/${fileId}`);
  },
};

export default XabarnomaService;
